import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ErrorComponent } from './error/error.component';
import { DashboardPreviewComponent } from './dashboard-preview/dashboard-preview.component';
import { MenuSideComponent } from './menu-side/menu-side.component';
import { LoaderComponent } from './loader/loader.component';
import { ScheduleNewComponent } from './schedule-new/schedule-new.component';
import { SelectListComponent } from './component/list-filter/select.list.component';
import { ChatbotComponent } from '../chatbot/chatbot.component';

//import { SharedComponent } from './shared.component';

//Spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedService } from './shared.service';

@NgModule({ 
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule
  ],
  declarations: [ 
    HeaderComponent,
    FooterComponent,
    ErrorComponent,
    DashboardPreviewComponent,
    MenuSideComponent,
    LoaderComponent,
    ScheduleNewComponent,
    SelectListComponent,
    ChatbotComponent
  ],
    
  exports: [
    HeaderComponent,
    FooterComponent,
    ErrorComponent,
    DashboardPreviewComponent,
    MenuSideComponent,
    LoaderComponent,
    ScheduleNewComponent,
    SelectListComponent,
    ChatbotComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend/src/app/shared/shared.module.ts